__turbopack_context__.v({
  "rotate": "YJM1WG_rotate",
  "spinner": "YJM1WG_spinner",
  "spinner--lg": "YJM1WG_spinner--lg",
  "spinner--light": "YJM1WG_spinner--light",
  "spinner--md": "YJM1WG_spinner--md",
  "spinner--sm": "YJM1WG_spinner--sm",
  "spinner--xl": "YJM1WG_spinner--xl",
  "spinner--xs": "YJM1WG_spinner--xs",
});
